import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import AlertsCollection, { CustomAlert } from 'components/AlertsCollection';
import TextField from 'components/DesignSystem/TextField';
import Button from 'components/DesignSystem/Button';
import { useLoginMutation } from '../../services/api/auth';
import { processLogin, initialAlerts } from './utils';

export default function Login() {
  const [login, { isLoading: isLoginLoading }] = useLoginMutation({ fixedCacheKey: 'loginOperation' });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const [alerts, setAlerts] = useState<CustomAlert[]>(initialAlerts(location.state));

  return (
    <>
      <Card.Title className="auth-card-title my-5">
        Espaço Exclusivo Ampere
      </Card.Title>
      <AlertsCollection alerts={alerts} />
      <Card.Body className="my-3 mx-5">
        <Form
          onSubmit={(event) => (processLogin(
            event,
            login,
            username,
            password,
            navigate,
            location,
            setValidated,
            setAlerts,
          ))}
          noValidate
          validated={validated}
        >
          <fieldset disabled={isLoginLoading}>
            <TextField
              required
              label="Username ou e-mail"
              type="email"
              onChange={(e) => setUsername(e.target.value)}
              error={validated && !username ? 'Por favor insira um e-mail válido.' : undefined}
              className="mb-3"
              controlId="loginFormUsername"
            />
            <TextField
              label="Senha"
              required
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              error={validated && !password ? 'Por favor insira a senha.' : undefined}
              controlId="loginFormPassword"
            />
            <Stack direction="horizontal" gap={3} className="mt-5 mb-2">
              <Button
                type="tertiary"
                onClick={() => navigate('/password-recovery')}
                className="ms-auto"
              >
                Esqueci minha senha
              </Button>
              <Button submit>Login</Button>
            </Stack>
          </fieldset>
        </Form>
      </Card.Body>
    </>
  );
}
